import { render, staticRenderFns } from "./apply-datum-info.vue?vue&type=template&id=4b850b36&scoped=true"
import script from "./apply-datum-info.vue?vue&type=script&lang=ts"
export * from "./apply-datum-info.vue?vue&type=script&lang=ts"
import style0 from "./apply-datum-info.vue?vue&type=style&index=0&id=4b850b36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b850b36",
  null
  
)

export default component.exports